import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import { BACKGROUND_CATEGORIES, BLACK, PRIMARY } from "../../styles/color";
import { useDispatch, useSelector } from "react-redux";
import "../CSS/Featured.css";
import { useGetAPIWithoutTokenQuery } from "../../Api/api";
import { useThemeColors } from "../../Context/Theme";
const FeaturedCategories = ({ eventName }) => {
  const navigate = useNavigate();
  const {
    primaryColor,
    secondaryColor,
    textColor,
    buttonColor,
    linkColor,
    backgroundColor,
    logo,
    fontFamily,
    fontWeight,
    fontSize,
    fontFamilyHeading,
    fontWeightHeading,
    fontSizeHeading,
  } = useThemeColors();



  const dispatch = useDispatch();

  const eventId = sessionStorage.getItem("event_id");

  const { data, isLoading, isError, isSuccess } = useGetAPIWithoutTokenQuery(
    `/api/category/readAllCategories?event_id=${eventId}&type=category&page=1&limit=10000`, { refetchOnMountOrArgChange: true, skip: !eventId}
  );

  const categories = Array.isArray(data?.data) ? data.data?.filter(n => n.parent_id === 0) : [];

  const handleSeeAll = () => {
    navigate(`/events/${eventName}/shop`, { state: { category: "all" } });
  };

  return (
    <div
      className="event_featuredCategories fo_css_event_featured_categories"
      style={{
        width: "100%",
        maxWidth: "91.6%",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        margin: "0 auto",
      }}
    >
      <div
        style={{
          margin: "0px 0px",
          display: "flex",
          flexDirection: "column",
          alignSelf: "center",
          width: "100%",
        }}
        className="width"
      >
        <div
          className="d-flex justify-content-between "
          style={{
            width: "100%",

          }}
        >
          <p
            style={{
              fontSize: fontSizeHeading || "30px",
              fontWeight: fontWeightHeading || "700",
              color: textColor || "black",
              fontFamily: fontFamilyHeading
            }}
          >
            Featured Categories
          </p>
          <p
            onClick={handleSeeAll}
            style={{
              fontSize: fontSizeHeading || "20px",
              fontWeight: fontWeightHeading || "400",
              color: primaryColor || PRIMARY,
              cursor: "pointer",
              fontFamily: fontFamilyHeading
            }}
          >
            See all
          </p>
        </div>

        <Grid
          container
          spacing={2}
          justifyContent="space-evenly"
          alignItems="center"
          style={{
            paddingLeft: "1%",
          }}
        >
          {categories?.slice(0, 6).map((category, index) => {
            return (
              <Grid item xs={6} sm={4} md={2} key={category.id}>
                <Card
                  className="category-list fo_css_event_featured_categories_card"
                  style={{
                    margin: "13% 0px",
                    borderRadius: "20px",
                    textAlign: "center",
                    backgroundColor: BACKGROUND_CATEGORIES,
                    height: "21vh",
                    width: "100%",

                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    boxShadow: "none",
                  }}
                  key={index}
                >
                  <div
                    className="fo_css_event_featured_categories_card_content"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                      height: "100%",
                      width: '100%',
                    }}
                    onClick={() =>
                      navigate(`/events/${eventName}/shop`, {
                        state: { category: category?.category_id },
                      })
                    }
                  >
                    <img


                      src={category?.category_img_path}
                      alt={category?.category_name}
                      className="p-3"
                      style={{ objectFit: "contain", width: '80%', height: '80%' }}
                    />
                    {/* </div>
                  <div> */}
                    <p
                      style={{
                        fontSize: fontSize || "1vw",
                        fontWeight: fontWeight || "500",
                        color: "#1A1A1A",
                        fontFamily
                      }}
                    >
                      {category?.category_name}
                      {/* Display the category title */}
                    </p>
                  </div>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </div>
    </div>
  );
};

export default FeaturedCategories;
